import { Badge, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { cyrb53Hash } from 'utils/helpers';
import i18n from 'i18n';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import styles, { Tab, Tabs } from './styles';

const useStyles = makeStyles(styles);

export interface TabProps {
  label: string;
  count: string | number;
  disabled: boolean;
}

export interface Props {
  items: TabProps[];
  defaultValue?: number;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  onChange?: (value: number) => void;
}

const PermissionsTabs = ({
  items,
  defaultValue,
  role,
  companySelected,
  onChange,
}: Props) => {
  const classes = useStyles();
  const [value, setValue] = React.useState<number>(defaultValue || 0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    // eslint-disable-next-line no-unused-expressions
    onChange && onChange(newValue);
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <Grid
        style={{ flexGrow: 1 }}
        className={classes.tabs}
        data-testid={'autosky-permissiontabs'}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          className={clsx({
            [classes.tabsGreen]: inAdminView(role, companySelected),
            [classes.tabsGray]: inSuperAdminView(role, companySelected),
            [classes.tabsBlue]: inOperatorView(role, companySelected),
            [classes.tabsYellow]: companySelected,
          })}
        >
          {items.map((item, index) => (
            <Tab
              key={cyrb53Hash(item.label)}
              id={`tab-permissions-${index}`}
              disabled={item.disabled}
              className={clsx({
                [`${classes.tabGreen} ${classes.tab}`]: inAdminView(
                  role,
                  companySelected
                ),
                [`${classes.tabGray} ${classes.tab}`]: inSuperAdminView(
                  role,
                  companySelected
                ),
                [`${classes.tabBlue} ${classes.tab}`]: inOperatorView(
                  role,
                  companySelected
                ),
                [`${classes.tabYellow} ${classes.tab}`]: companySelected,
              })}
              label={
                <Badge
                  className={classes.badge}
                  badgeContent={
                    item.count === 'ALL_KEY'
                      ? i18n.t(`${'ALL_KEY'}`)
                      : item.count
                  }
                >
                  {i18n.t(`${item.label}_KEY`)}
                </Badge>
              }
            />
          ))}
        </Tabs>
      </Grid>
    </React.Fragment>
  );
};

export default PermissionsTabs;
